import { Avatar, Banner, Body, Container, Divider, Grid, Stack, StackItem, Title } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { DetailedPlatformProfileResult } from '@mews-commander/data-access';
import { useImageSrc } from '@mews-commander/utils';
import { PlatformProfile2FATag } from '../Common';
import { PlatformProfileActivityMetaData } from './PlatformProfileActivityMetaData';
import { EditPlatformProfileButton } from './EditPlatformProfile';
import { PlatformProfileData } from './PlatformProfileData';
import { TwoFactorAuthWarningBanner } from './TwoFactorAuthWarningBanner';

export const PlatformProfileDetailsContent = ({
    platformProfile,
    isLoading,
    isOwnProfile,
}: {
    platformProfile: DetailedPlatformProfileResult;
    isLoading: boolean;
    isOwnProfile: boolean;
}) => {
    const avatarSrc = useImageSrc(platformProfile.imageId) ?? '';

    return (
        <Stack spacing="300" vertical>
            {isOwnProfile && (
                <Banner
                    primaryText={<LocalizedText textKey={TextKey.UserManagementCannotEditOwnProfileBannerTitle} />}
                    secondaryText={<LocalizedText textKey={TextKey.UserManagementCannotEditOwnProfileBannerContent} />}
                    variant="info"
                />
            )}

            <StackItem>
                <Stack vertical spacing="300">
                    <Stack spacing="200">
                        <Stack spacing="200" itemAlignment="center" fill>
                            <Avatar src={avatarSrc} title={platformProfile.fullName || ''} size="extraLarge" />
                            <StackItem grow>
                                <Stack spacing="100" vertical itemAlignment="start">
                                    <StackItem>
                                        <Title level={3}>{platformProfile.fullName}</Title>
                                        <Body variant="secondary">{platformProfile.email}</Body>
                                    </StackItem>
                                    <PlatformProfile2FATag isEnabled={platformProfile.twoFactorAuthenticationEnabled} />
                                </Stack>
                            </StackItem>
                        </Stack>
                        {!isOwnProfile && <EditPlatformProfileButton disabled={isLoading} data={platformProfile} />}
                    </Stack>
                    {!platformProfile.twoFactorAuthenticationEnabled && <TwoFactorAuthWarningBanner />}
                    <Divider />
                </Stack>
                <Container padding={['500', '0']}>
                    <Grid columnGap="900" rowGap="500" templateColumns="1fr" largePhoneMax={{ templateColumns: '1fr' }}>
                        <PlatformProfileData platformProfile={platformProfile} />
                        <PlatformProfileActivityMetaData platformProfile={platformProfile} />
                    </Grid>
                </Container>
            </StackItem>
        </Stack>
    );
};
